import { Dispatch, SetStateAction, useCallback, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Checkbox } from 'core-components/library/checkbox'

import { TRANSLATION_KEYS } from '../../translations'

import { FormLocationsTextarea } from './components/formLocationsTextarea/FormLocationsTextarea'

import styles from './LocationsEditorDialogContent.module.scss'

interface ILocationsEditorDialogContentProps {
  isSaving?: boolean
  locations: string[]
  setLocations: Dispatch<SetStateAction<string[]>>
}

export const LocationsEditorDialogContent = ({
  locations,
  setLocations,
  isSaving,
}: ILocationsEditorDialogContentProps) => {
  const [locationsToRemove, setLocationsToRemove] = useState<string[]>([])

  const addNewLocations = useCallback(
    (newLocations: string[]) => {
      setLocations((prevState) => {
        const locationsSet = new Set(prevState)
        newLocations.forEach((it) => locationsSet.add(it))
        return Array.from(locationsSet)
      })
    },
    [setLocations]
  )

  const removeLocations = useCallback(() => {
    setLocations((prevState) => {
      return prevState.filter(
        (location) => !locationsToRemove.some((locationToRemove) => locationToRemove === location)
      )
    })
    setLocationsToRemove([])
  }, [setLocations, locationsToRemove])

  return (
    <fieldset className={styles.root} disabled={isSaving}>
      <FormLocationsTextarea onAddNewLocations={addNewLocations} />
      <div className={styles.removeContainer}>
        <Button disabled={locationsToRemove.length === 0} onClick={removeLocations} color="danger">
          <Translation text={TRANSLATION_KEYS.removeButton} span />
        </Button>
      </div>
      <div className={styles.listContainer}>
        {locations.map((location, index) => {
          return (
            <div className={styles.locationItem} key={`${location}:${index}`}>
              <Checkbox
                checked={locationsToRemove.some((it) => it === location)}
                label={`${index + 1}. ${location}`}
                onChange={(checked) => {
                  setLocationsToRemove((prevState) => {
                    return checked
                      ? [...prevState, location]
                      : prevState.filter((it) => location !== it)
                  })
                }}
              />
            </div>
          )
        })}
      </div>
    </fieldset>
  )
}
